// @flow
/* eslint-disable prefer-promise-reject-errors */

/**
 * Shamelessly lifted from https://github.com/facebook/react/issues/5465#issuecomment-157888325
 * @param promise
 * @returns {{cancel(): void, promise: Promise<unknown>}}
 */
const makeCancelable = (promise) => {
  let isCanceled = false;

  const wrappedPromise = new Promise((resolve, reject) => {
    promise.then((val) => (isCanceled ? reject({ isCanceled }) : resolve(val)));
    promise.catch((error) =>
      isCanceled ? reject({ isCanceled }) : reject(error)
    );
  });

  return {
    promise: wrappedPromise,
    cancel() {
      isCanceled = true;
    }
  };
};

export default makeCancelable;
